import { useEffect, useRef } from 'react'
import { Props_SnippetGeneralCarousel } from './GeneralCarousel.props'
import { Legacy_CompileMarkdown } from '@ClientBase/React/ReactSnippetMDCompiler'
import { createGeneralCarousel } from '../Carousels'

const SnippetGeneralCarousel = (props: Props_SnippetGeneralCarousel) => {
    const carouselRef = useRef<HTMLDivElement>(null)
    const { heading, repeatable_entry } = props
    const classHeadingVisibility: string = heading.visibility.value ? `snippet-general-carousel__heading--${heading.visibility.value}` : ''

    useEffect(() => {
        createGeneralCarousel(carouselRef)
    }, [])

    return (
    <section className="snippet-general-carousel">
        <div className={`snippet-general-carousel__container`}>
            <h2 className={`snippet-general-carousel__heading ${classHeadingVisibility}`}>{ heading.content.value }</h2>
            <div className="snippet-general-carousel__container-entries" ref={carouselRef}>
            { repeatable_entry.map((entry, index: number) => (
                <div key={index} className={`snippet-general-carousel__entry`}>
                    { entry.image?.value && (
                        <figure className="snippet-general-carousel__entry-image-container">
                            <img
                                className="snippet-general-carousel__entry-image"
                                loading="lazy"
                                height={190}
                                width={350}
                                src={entry.image.value}
                                alt={entry.alt?.value ? entry.alt.value : ''}
                            />
                        </figure>
                    )}
                    <div className="snippet-general-carousel__entry-content-container">
                        { entry.heading?.value && <h3 className="snippet-general-carousel__entry-title">{ entry.heading.value }</h3>}
                        { entry.content?.value && <div className="snippet-general-carousel__entry-content">{ Legacy_CompileMarkdown(entry.content.value) }</div> }
                        { entry.linkContent?.value && entry.linkUrl?.value && entry.linkTarget?.value && (
                            <a
                                href={entry.linkUrl.value}
                                className="snippet-general-carousel__entry-link"
                                target={entry.linkTarget.value === 'true' ? '_blank' : '_self'}
                                rel={entry.linkTarget.value === 'true' ? 'noopener noreferrer' : ''}
                            >
                                { entry.linkContent.value }
                            </a>
                        )}
                    </div>
                </div>
            ))}
            </div>
        </div>
    </section>
    )
}

export default SnippetGeneralCarousel